@if (this.selectedFunction) {
<h3
  class="mt-2"
  i18n="@@supervisor-function"
>
  Supervisor-Funktion
</h3>
<div class="mt-3">
  <input
    pInputText
    type="text"
    [(ngModel)]="this.selectedFunction.name"
    [ngModelOptions]="{updateOn: 'blur'}"
    (ngModelChange)="this.rss.saveBotConfigField('supervisorFunctions')"
    fluid
  >
</div>
<app-codemirror-dann
  #codeEditor
  [code]="this.selectedFunction.js"
  [stages]="this.stageAdmin.getStageNames()"
  [skills]="this.getSkillNames()"
  [rows]="13"
  (finish)="this.selectedFunction.js = $event.code; this.rss.saveBotConfigField('supervisorFunctions')"
></app-codemirror-dann>
}